import { render } from "./StatsComponent.vue?vue&type=template&id=265a63a1&scoped=true"
import script from "./StatsComponent.vue?vue&type=script&lang=js"
export * from "./StatsComponent.vue?vue&type=script&lang=js"

import "./StatsComponent.vue?vue&type=style&index=0&id=265a63a1&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-265a63a1"

export default script